var didTheySayThat = require('./did-they-say-that')
var quiz2 = require('./quiz2')
var humanRights = require('./humanrights')

module.exports = [
  didTheySayThat,
  quiz2,
  humanRights,
]

